const zh = {
    "common": {
       "querysearch": "请输入查询条件",
       "querybtn": "查询"
    },
    "login": {
      "loginTitle": "一恒科海外智能管理平台",
      "loginSubTitle": "I.HengKe management platform",
      "placeholderLoginName": "请输入用户名",
      "placeholderpassword": "请输入密码",
      "submitLogin": "正在登录...",
      "loginForm": "登      录"
    },
    "home": {
       "editPasswd": "修改密码",
       "exitLogin": "退出登录"
    },
    "userList": {
      "adduserBtn": "新增用户"
    }
  }

  export default zh



// WEBPACK FOOTER //
// ./src/assets/languages/zh.js